import {useMutation} from "@tanstack/react-query";
import {freePaymentUrl} from "../../constants/api/endpoints";
import {useAxios} from "../../hooks/axios/useAxios";
import {toast} from "react-toastify";

export const useFreePayment = ({
                                 payment_intent_id,
                                 portfolio_id
                               }: { payment_intent_id?: string, portfolio_id?: string | null }) => {
  const axios = useAxios();

  async function postData() {
    return axios.post(freePaymentUrl,
      {
        payment_intent_id,
        portfolio_id
      }
    )
      .then(response => response?.data)
  }

  return useMutation({
    mutationKey: ['apply-promo', payment_intent_id],
    mutationFn: postData,
    retry: 1,
    onSuccess: () => toast.success('Payment was successful!'),
    onError: (error) => {
      // @ts-ignore
      toast.error(error?.response?.data?.error ?? 'Unexpected error occurred. Please try again.')
    }
  });
}
